import { BillingCycleTypes } from '../../domain/invoice';
import { LicenseStatusTypes } from '../../domain/license';
import { ISortable } from '../../../../app/helpers/sort';
import { MemberDashboardMembershipUserResponseArray } from './member.dashboard.membership.user.response';

export enum MembershipStatusTypes {
    Active = 1,
    Cancelled = 2,
}

export interface IMemberDashboardMembershipResponse {

    ID: number;
    MemberID: number;
    MemberFirstName: string;
    MemberLastName: string;
    Product: string;
    StartDate: Date;
    BillingCycle: BillingCycleTypes;
    NextBillDate: Date;
    Status: MembershipStatusTypes;
    HasNotes: boolean;
    MembershipUsers: MemberDashboardMembershipUserResponseArray;
}

export class MemberDashboardMembershipResponse implements IMemberDashboardMembershipResponse {

    ID: number;
    MemberID: number;
    MemberFirstName: string;
    MemberLastName: string;
    Product: string;
    StartDate: Date;
    BillingCycle: BillingCycleTypes;
    BillingAmount: number;
    NextBillDate: Date;
    DateTimeCreated: Date;
    Status: MembershipStatusTypes;
    HasNotes: boolean;
    MembershipUsers: MemberDashboardMembershipUserResponseArray;

    public static FixDate(membership: MemberDashboardMembershipResponse) {
        membership.NextBillDate = new Date(membership.NextBillDate);
        membership.DateTimeCreated = new Date(membership.DateTimeCreated);
    }

}

export class MemberDashboardMembershipResponseArray extends Array<MemberDashboardMembershipResponse>  {

    constructor(...items: MemberDashboardMembershipResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberDashboardMembershipResponseArray.prototype);
    }

    public static FixDates(licenses: MemberDashboardMembershipResponseArray) {

        licenses.forEach(x => {
            x.NextBillDate = new Date(x.NextBillDate);
            x.DateTimeCreated = new Date(x.DateTimeCreated);
        });

    }


}
